export default class Document {
    public name?: string;
    public fileExtension?: string;
    public dateCreated?: Date;
    public dateModified?: Date;
    public fileData?: Blob;
    public contentType: string;

    constructor(obj: any) {
        this.name = obj?.name;
        this.fileExtension = obj?.fileExtension;
        this.dateCreated = obj?.dateCreated;
        this.dateModified = obj?.dateModified;
        this.fileData = obj?.fileData;
        this.contentType = obj?.contentType;
    }
}
